export default __webpack_public_path__ + "static/media/hire-purchase-chart-1.4bb600ff.svg";